/* MUTO product page — gallery and buy box.
 *
 * One source of truth: the currently selected option (a subscribe plan card, or
 * the one-time segment). Selecting writes the variant id and selling plan into
 * the add-to-cart form's hidden inputs and repaints the CTA, the plan cards and
 * the sticky bar.
 *
 * Idempotent, and re-binds on Shopify's theme editor section events.
 */
(function () {
  'use strict';

  /* ---------------------------------------------------------------- gallery */
  function initGallery(root) {
    var rail = root.querySelector('[data-mp-rail]');
    if (!rail) return;

    var slides = rail.querySelectorAll('[data-mp-slide]');
    var thumbs = root.querySelectorAll('[data-mp-thumb]');
    var count = root.querySelector('[data-mp-count]');
    if (!slides.length) return;

    var current = -1;
    var frame = null;

    function paint(index) {
      if (index === current) return;
      current = index;
      if (count) count.textContent = index + 1 + ' / ' + slides.length;
      for (var i = 0; i < thumbs.length; i++) {
        thumbs[i].classList.toggle('is-active', i === index);
      }
    }

    function readScroll() {
      frame = null;
      // clientWidth, not a hard-coded 430 — the column is fluid.
      var w = rail.clientWidth || 1;
      var i = Math.round(rail.scrollLeft / w);
      paint(Math.max(0, Math.min(slides.length - 1, i)));
    }

    rail.addEventListener(
      'scroll',
      function () {
        if (frame) return;
        frame = window.requestAnimationFrame(readScroll);
      },
      { passive: true }
    );

    for (var i = 0; i < thumbs.length; i++) {
      (function (index) {
        thumbs[index].addEventListener('click', function () {
          rail.scrollTo({ left: index * rail.clientWidth, behavior: 'smooth' });
          // Paint immediately; the scroll handler confirms once it settles.
          paint(index);
        });
      })(i);
    }

    window.addEventListener('resize', function () {
      current = -1;
      readScroll();
    });

    paint(0);
  }

  /* --------------------------------------------------------------- buy box */
  function initBuy(root) {
    var variantInput = root.querySelector('[data-mp-variant-input]');
    if (!variantInput) return;

    var planInput = root.querySelector('[data-mp-plan-input]');
    var plansBox = root.querySelector('[data-mp-plans]');
    var cards = root.querySelectorAll('[data-mp-plan]');
    var segButtons = root.querySelectorAll('[data-mp-seg]');
    var onceSeg = root.querySelector('[data-mp-seg="once"]');
    var ctaPrice = root.querySelectorAll('[data-mp-cta-price]');
    var cta = root.querySelector('[data-mp-cta]');
    var barLabel = root.querySelector('[data-mp-bar-label]');
    var barSub = root.querySelector('[data-mp-bar-sub]');

    // Remembered so switching to One-time and back restores the same plan.
    var lastPlan = null;
    for (var i = 0; i < cards.length; i++) {
      if (cards[i].classList.contains('is-selected')) lastPlan = cards[i];
    }
    if (!lastPlan && cards.length) lastPlan = cards[0];

    function apply(source) {
      if (!source) return;

      variantInput.value = source.getAttribute('data-variant-id') || '';

      // An empty selling_plan must not be posted at all, or /cart/add rejects
      // it — disable the input instead of sending a blank value.
      if (planInput) {
        var plan = source.getAttribute('data-selling-plan') || '';
        planInput.value = plan;
        planInput.disabled = plan === '';
      }

      var price = source.getAttribute('data-price') || '';
      for (var i = 0; i < ctaPrice.length; i++) ctaPrice[i].textContent = price;

      if (barLabel) {
        var bl = source.getAttribute('data-bar-label') || '';
        barLabel.textContent = bl ? bl + ' · ' + price : price;
      }
      if (barSub) barSub.textContent = source.getAttribute('data-bar-sub') || '';

      var sold = source.getAttribute('data-available') === 'false';
      if (cta) {
        cta.disabled = sold;
        if (sold) cta.setAttribute('aria-disabled', 'true');
        else cta.removeAttribute('aria-disabled');
      }
    }

    function selectPlan(card) {
      if (!card || card.classList.contains('is-unavailable')) return;
      lastPlan = card;
      for (var i = 0; i < cards.length; i++) {
        cards[i].classList.toggle('is-selected', cards[i] === card);
      }
      var radio = card.querySelector('input[type="radio"]');
      if (radio) radio.checked = true;
      apply(card);
    }

    function setMode(mode) {
      for (var i = 0; i < segButtons.length; i++) {
        var isActive = segButtons[i].getAttribute('data-mp-seg') === mode;
        segButtons[i].classList.toggle('is-active', isActive);
        segButtons[i].setAttribute('aria-pressed', isActive ? 'true' : 'false');
      }
      if (plansBox) plansBox.hidden = mode !== 'sub';
      if (mode === 'sub') selectPlan(lastPlan);
      else apply(onceSeg);
    }

    for (var i = 0; i < cards.length; i++) {
      (function (card) {
        var radio = card.querySelector('input[type="radio"]');
        if (radio) {
          radio.addEventListener('change', function () {
            if (radio.checked) selectPlan(card);
          });
        }
      })(cards[i]);
    }

    for (var j = 0; j < segButtons.length; j++) {
      (function (button) {
        button.addEventListener('click', function () {
          setMode(button.getAttribute('data-mp-seg'));
        });
      })(segButtons[j]);
    }

    // The sticky bar has no form of its own — it submits the buy box's.
    var stickyCta = root.querySelector('[data-mp-sticky-cta]');
    var form = root.querySelector('form');
    if (stickyCta && form) {
      stickyCta.addEventListener('click', function () {
        if (typeof form.requestSubmit === 'function') form.requestSubmit();
        else form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
      });
    }

    // Paint from whatever the server rendered as selected.
    var startMode = 'sub';
    for (var k = 0; k < segButtons.length; k++) {
      if (segButtons[k].classList.contains('is-active')) {
        startMode = segButtons[k].getAttribute('data-mp-seg');
      }
    }
    if (!cards.length) startMode = 'once';
    setMode(startMode);
  }

  function initAll(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var roots = scope.querySelectorAll('[data-mp-pdp]');
    for (var i = 0; i < roots.length; i++) {
      if (roots[i].dataset.mpReady === 'true') continue;
      roots[i].dataset.mpReady = 'true';
      initGallery(roots[i]);
      initBuy(roots[i]);
    }
    if (scope !== document && scope.matches && scope.matches('[data-mp-pdp]')) {
      if (scope.dataset.mpReady !== 'true') {
        scope.dataset.mpReady = 'true';
        initGallery(scope);
        initBuy(scope);
      }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll(document);
    });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
